// extracted by mini-css-extract-plugin
module.exports = {"button":"MenuGenderPages_button__XIMM9","btnContainer":"MenuGenderPages_btnContainer__6XfhH"};